<template>
  <div
    :class="['sidebar', { 'collapse': isCollapse }, { 'sidebar_fixed' : isSticky }, { 'sidebar_xueshi' : isXueshi }]"
    @mouseover="isCollapse = true"
    @mouseout="isCollapse = false">
    <div>
      <router-link tag="div" :to="isXueshi ? '/xueshi-iJournal/user/follow' : '/user/follow'" class="item">
        <i class="iconfont iconshoucang"></i>
        <span class="margin-top-5" v-show="isCollapse">我的关注</span>
      </router-link>
      <router-link tag="div" :to="isXueshi ? '/xueshi-iJournal/user/comment' : '/user/comment'" class="item">
        <i class="iconfont iconpinglun"></i>
        <span class="margin-top-5" v-show="isCollapse">我的评论</span>
      </router-link>
    </div>
    <div class="item back_top" @click="scrollToTop">
      <i class="iconfont iconxiangshang"></i>
    </div>
  </div>
</template>

<script>
import { throttle } from 'throttle-debounce'
export default {
  data () {
    return {
      // 是否展开
      isCollapse: false,
      // 是否吸顶
      isSticky: false
    }
  },
  computed: {
    isXueshi () {
      return this.$route.path.indexOf('/xueshi-iJournal') === 0
    }
  },
  mounted () {
    this.throttledScrollHandler = throttle(100, this.onScroll)
    document.addEventListener('scroll', this.throttledScrollHandler)
  },
  methods: {
    // 判断是否吸顶
    onScroll () {
      let el = document.querySelector('html')
      const scrollTop = el.scrollTop
      this.isSticky = scrollTop >= 51
    },
    // 回到顶部
    scrollToTop () {
      this.isXueshi ? document.getElementById('app').scrollIntoView() : document.getElementById('header').scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
  /*
    1、当元素在屏幕内，表现为relative，就要滚出显示器屏幕的时候，表现为fixed
    2、粘性定位还是占位置的 要让其浮动 才能不占位置
    3、父级元素不能有任何overflow:visible以外的overflow设置。（包括祖父元素）
    4、父级元素也不能设置固定的height高度值，否则也没有粘滞效果
    5、如果是水平滚动，也可以设置left和right值。
    6、父元素的高度不能低于sticky元素的高度
  */
  .sidebar {
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    position: absolute;
    top: 51px;
    bottom: 0px;
    right: 0px;
    width: 40px;
    padding-top: 11px;
    background: #ffffff;
    box-shadow: 0px 5px 6px rgba(0,0,0,0.16);
    z-index: 200;
    transition: width 0.3s ease;
    &.collapse {
      width: 60px;
    }
    &.sidebar_fixed {
      position: fixed;
      top: 0;
    }
    &.sidebar_xueshi {
      top: 0;
    }
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 70px;
      padding-top: 14px;
      font-size: 12px;
      color: #909399;
      cursor: pointer;
      &.back_top {
        position: absolute;
        top: 74.3%;
        padding-top: 0;
        justify-content: center;
      }
      &:hover {
        background-color: #F2F5F9;
        color: $color-primary;
        & > i {
          color: $color-primary;
        }
      }
      & > i {
        font-size: 20px;
        color: $color-text-primary;
      }
      & > span {
        text-align: center;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue